import Vue from 'vue'
import Router from 'vue-router'
import TokenRedirect from "@/components/TokenRedirect";
import TheContainer from '@/components/container/TheContainer.vue';
import Dashboard from "@/views/Dashboard/Dashboard.vue";
import Accounts from '@/views/Accounts/index.vue';
import AccountsView from "@/views/Accounts/AccountsView.vue";
import Organization from "@/views/Organization/Organization.vue"
import Task from "@/views/Task/Tasks.vue"
import Leads from "@/views/Leads/Leads.vue";
import Instructor from "@/views/Instructor/Instructor.vue";
import Candidates from "@/views/Candidates/Candidates.vue";
import Search from "@/views/Search/Search.vue";
import Reports from "@/views/Reports/school.vue";
import Pitch from "@/views/Pitches/Pitches.vue";
import Internships from "@/views/internship/Internships.vue";
import crmLoader from "@/views/crmLoader.vue";
import Alumni from "@/views/Alumni/Alumni.vue";
import newsLatterEmails from "@/views/NewsMail/NewsLatterEmails.vue"
import Resume from "@/views/Resume/index.vue"
import Communication from "@/views/Communications/index.vue"
import Emails from "@/views/Communications/Email/index.vue"
import Notifications from "@/views/Communications/Notification/index.vue"
import Questionnaires from "@/views/Communications/Questionnaire/index.vue"
import Matrix from "@/views/Matrix/index.vue";
import Calendar from "@/views/Calendar/index.vue"


const isTesing = process.env.NODE_ENV !== "production";
Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/crm/:site_token?/:crm_token?',
            name: 'crm_init',
            component: crmLoader
        },
        {
            path: '/',
            name: 'mani-container',
            component: TheContainer,
            children: [{
                path: '/',
                name: 'dashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/calendar',
                name: 'calendar',
                component: Calendar,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/school/:type?',
                name: 'organization',
                component: Organization,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/school/classes/:team_id',
                name: 'view-team',
                component: Organization,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/accounts/:type?/:id?',
                name: 'accounts',
                component: Accounts,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/task/:id?',
                name: 'task',
                component: Task,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/leads/:id?',
                name: 'leads',
                component: Leads,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/instructor/:main_menu?/:sub_menu?',
                name: 'instructor',
                component: Instructor,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/candidates/:id?',
                name: 'candidates',
                component: Candidates,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/resumes',
                name: 'resumes',
                component: Resume,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/pitch/',
                name: 'pitch',
                component: Pitch,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/accounts/view/:type/:id',
                name: 'account-view',
                component: AccountsView,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/accounts/view/:type/:id/:note_id',
                name: 'account-note-view',
                component: AccountsView,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/internship',
                name: 'assignment',
                component: Internships,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/search',
                name: 'search',
                component: Search,
                meta: {
                    requiresAuth: true,
                }
            },

            {
                path: '/reports/:type?',
                name: 'reports',
                component: Reports,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/alumni/',
                name: 'alumni',
                component: Alumni,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/newsletter/',
                name: 'newsletter',
                component: newsLatterEmails,
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/communications',
                name: 'communications',
                component: Communication,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '/emails',
                        name: 'emails',
                        component: Emails,
                    },
                    {
                        path: '/notifications',
                        name: 'notifications',
                        component: Notifications,
                    },
                    {
                        path: '/questionnaires',
                        name: 'questionnaires',
                        component: Questionnaires,
                    },
                ]
            },
            {
                path: '/matrix/',
                name: 'matrix',
                component: Matrix,
                meta: {
                    requiresAuth: true,
                }
            },
            ]
        },
        {
            path: '/social-login/:provider/:id',
            name: 'log-token',
            component: TokenRedirect
        },
        {
            path: '*',
            redirect: '/page-not-found'
        },
    ]
})